import React from 'react';
import PropTypes from 'prop-types';
import Cleave from 'cleave.js/react';
import css from './Input.module.scss';

class CustomCleave extends React.Component {
  onChange = event => {
    event.preventDefault();
    const value = this.props.rawValue
      ? event.target.rawValue
      : event.target.value;
    this.setState({ value });
    this.props.onChange(value);
  };

  render() {
    const {
      placeholder,
      format,
      options,
      error,
      onChange,
      rawValue,
      icon,
      alwaysShowLabelAbove,
      tidy,
      disabled,
      ...rest
    } = this.props;

    return (
      <Cleave
        {...rest}
        onChange={this.onChange}
        placeholder={this.props.placeholder}
        options={options}
        className={css.Input}
      />
    );
  }
}

CustomCleave.propTypes = {
  style: PropTypes.string
};

export default CustomCleave;
